import { render, staticRenderFns } from "./m22.vue?vue&type=template&id=126a16be&scoped=true&"
import script from "./m22.vue?vue&type=script&lang=js&"
export * from "./m22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126a16be",
  null
  
)

export default component.exports